import React from 'react';
import ReactDOM from 'react-dom/client';
import MainApp from './MainApp';
import { BrowserRouter } from "react-router";
import ProjectConstants from "./projectConstants";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices/main";
import './assets/css/main.scss';

const store = configureStore({ reducer: rootReducer, devTools: true });

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={import.meta.env.VITE_APP_BASE_URL}>
        <MainApp />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);